<template>
  <div class="w100 pl20 bg-w pr20 pt20 pb20" v-loading="loading">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane name="bpmnPageProcess">
        <span slot="label"> 全部 </span>
      </el-tab-pane>
      <el-tab-pane name="bpmnPageOwenProcess">
        <span slot="label">
          我发起的 <el-badge :value="tabJson.owntasks || ''" class="item"></el-badge>
        </span>
      </el-tab-pane>
      <el-tab-pane name="bpmnPageTodoProcess">
        <span slot="label">
          我的待办 <el-badge :value="tabJson.mytasks || ''" class="item"></el-badge>
        </span>
      </el-tab-pane>
      <el-tab-pane name="bpmnPageHasdoneProcess">
        <span slot="label">
          我的已办 <el-badge :value="tabJson.mydonetasks || ''" class="item"></el-badge>
        </span>
      </el-tab-pane>
      <el-tab-pane name="getMyReportList">
        <span slot="label">
          填报任务 <el-badge :value="tabJson.reporttasks || ''" class="item"></el-badge>
        </span>
      </el-tab-pane>
      <el-tab-pane name="getPageCs">
        <span slot="label"> 抄送 <el-badge :value="numCs" class="item"></el-badge> </span>
      </el-tab-pane>
    </el-tabs>
    <div class="table-con">
      <!-- <div class="M_search" style="justify-content:flex-end" v-if="activeName=='getMyReportList'">
                <div class="rightBtn">
                    <el-button
                            style="float: right"
                            type="primary"
                            icon="el-icon-document"
                            @click="toRoute"
                    >发起填报任务
                    </el-button>
                </div>
            </div> -->
      <ul v-if="!allExport">
        <div
          v-if="activeName == 'bpmnPageProcess'"
          style="display: flex; align-items: center; justify-content: flex-start"
        >
          <span>活动方案名称：</span>
          <el-input
            style="width: 200px; margin-right: 10px"
            v-model="seach"
            placeholder="请输入方案关键字"
          ></el-input>
          <el-button type="primary" @click="getListFn">查询</el-button>
        </div>
        <div v-if="activeName == 'getPageCs'">
          <el-select v-model="cpType" placeholder="请选择阅读状态" @change="cpChange">
            <el-option label="待阅" value="0"></el-option>
            <el-option label="已阅" value="1"></el-option>
          </el-select>
        </div>
        <div
          v-if="
            activeName == 'bpmnPageOwenProcess' ||
            activeName == 'bpmnPageTodoProcess' ||
            activeName == 'bpmnPageHasdoneProcess'
          "
          style="display: flex; align-items: center; justify-content: flex-start"
        >
          <span>业务名称：</span>
          <el-input
            style="width: 200px; margin-right: 10px"
            v-model="bussKeywords"
            placeholder="请输入业务关键字"
          ></el-input>
          <span style="margin-left: 10px">单号：</span>
          <el-input
            style="width: 200px; margin-right: 10px"
            v-model="billNo"
            placeholder="请输入业务关键字"
          ></el-input>
          <el-button type="primary" @click="getListFn">查询</el-button>
        </div>
        <li
          v-if="list.length && !loading"
          v-for="item in list"
          class="cl-f"
          @click="liClick(item)"
          :class="{
            bpmnPageProcess:
              activeName == 'bpmnPageProcess' || activeName == 'getMyReportList',
          }"
        >
          <el-row class="rows">
            <el-col class="cols" :span="1" align="center">
              <img class="icon" :src="`${baseUrl}images/file_icon.png`"
            /></el-col>
            <el-col class="cols" :span="4.5">
              <span class="name bold" v-text="item.instId || ''"></span>
            </el-col>
            <el-col class="cols" :span="11">
              <el-tooltip
                effect="dark"
                :content="item.serveName||item.taskName||item.reportName"
                placement="top"
              >
                 <span class="name bold"  v-text="item.serveName||item.taskName||item.reportName" ></span>
              </el-tooltip>
            </el-col>
            <el-col class="cols" :span="7" align="right">
              <span
                style="display: block; text-align: left"
                v-if="activeName == 'bpmnPageOwenProcess'"
              >
                <span
                  class="spanBtn"
                  :style="{
                    'background-color':
                      item.processStatus == '中断'
                        ? '#C280FF'
                        : item.processStatus == '已完成'
                        ? '#60E46D'
                        : '#81D3F8',
                  }"
                >
                  {{ item.processStatus }}
                </span>
                <i class="el-icon-time"></i>
                {{ item.createTime && getDateDiff(item.createTime) }}</span
              >
              <span
                class="fr"
                v-if="
                  activeName == 'bpmnPageTodoProcess' ||
                  activeName == 'bpmnPageHasdoneProcess' ||
                  activeName == 'getPageCs'
                "
              >
                <i class="el-icon-time"></i>
                {{ item.createTime && getDateDiff(item.createTime) }}</span
              >
              <span v-if="activeName == 'getMyReportList'" class="fr reportStatus">
                <el-button
                  size="mini"
                  :type="item.reportStatus != 0 ? '' : 'primary'"
                  :disabled="item.reportStatus != 0"
                  @click="item.reportStatus == 0 && handleReportList(item)"
                >
                  {{ item.reportStatus != 0 ? "已上报" : "待上报" }}</el-button
                >
              </span>
              <span
                v-if="activeName == 'getMyReportList'"
                v-show="item.endDate"
                class="fr"
                style="margin-right: 10px; color: #666"
                v-text="item.endDate"
              ></span>
              <span
                v-if="activeName == 'getMyReportList'"
                class=""
                style="color: #666"
                v-text="item.deptName"
              ></span>
              <span v-if="activeName == 'bpmnPageProcess'" class="mytasks fr task-num">
                待办 {{ item.mytasks }}
              </span>
              <span v-if="activeName == 'bpmnPageProcess'" class="histasks fr task-num">
                已办 {{ item.histasks }}
              </span>
            </el-col>
          </el-row>
        </li>
        <div v-if="list.length == 0 && !loading" class="no-data">无查询结果。</div>
      </ul>
      <div v-if="activeName == 'bpmnPageProcess' && allExport">
        <div style="display: flex; align-items: center; justify-content: space-between">
          <i @click="goBack" class="el-icon-arrow-left" style="font-size: 24px"></i>
          <div>
            <el-button
              type="primary"
              :disabled="!instIdRow.length"
              @click="spClick('AGREE')"
              >批量通过</el-button
            >
            <el-button
              type="danger"
              :disabled="!instIdRow.length"
              @click="spClick('REFUSE')"
              >批量驳回</el-button
            >
          </div>
        </div>
        <div class="advice-main">
          <el-table
            class="w100 mt20 table"
            @selection-change="handleSelectionChange"
            :show-header="true"
            header-row-class-name="table-head"
            v-loading="loadingSp"
            height="620"
            :data="tableData"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="任务名称">
              <template slot-scope="scope">
                <span v-text="scope.row.taskName"></span>
                <span>[{{ scope.row.xqmc }}]</span>
                <span
                  v-if="lxShow"
                  :style="{ color: scope.row.qfje == 0 ? '#4cdd1c' : '#ff210b' }"
                  >{{ scope.row.qfje == 0 ? "(学费已交清/" : "(学费未交清/" }}</span
                >
                <span
                  v-if="lxShow"
                  :style="{ color: scope.row.sbwh == 0 ? '#4cdd1c' : '#ff210b' }"
                  >{{ scope.row.sbwh == 0 ? "图书已归还)" : "图书未归还)" }}</span
                >
              </template>
            </el-table-column>
            <el-table-column prop="type" align="center" label="任务状态" width="120">
              <template slot-scope="scope">
                <div style="width: 120px; background-color: #81d3f8; color: #ffffff">
                  进行中
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="创建时间"
              prop="createTime"
              align="center"
              width="200"
            ></el-table-column>
          </el-table>
        </div>
        <div class="mt20 flex-box">
          <div class="flex-1"></div>
          <el-pagination
            background
            @size-change="changeProSize"
            @current-change="changeProPage"
            :current-page="paramProSearch.current"
            :page-sizes="pageProSizes"
            :page-size="paramProSearch.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="paramProSearch.total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <div class="mt20 flex-box" v-if="!allExport">
      <div class="flex-1"></div>
      <el-pagination
        background
        @size-change="changeSize"
        @current-change="changePage"
        :current-page="paramSearch.current"
        :page-sizes="pageSizes"
        :page-size="paramSearch.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <IframeView ref="IframeView" @sub-true="subTrue"></IframeView>
    <batchModel :leaData="leaData" @close="getPage"></batchModel>
  </div>
</template>

<script>
import * as serve from "@/api/bpmnApi/bpmn";
import { getDateDiff } from "@/util/utils";
import IframeView from "@/components/public/IframeView.vue";
import batchModel from "@/views/mine/myAffair/batchModel.vue";
export default {
  name: "myAffair",
  components: {
    IframeView,
    batchModel,
  },
  props: [],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      list: [],
      reportList: [],
      pageSizes: [10, 20, 30, 50, 100],
      paramSearch: {
        current: 1,
        size: 10,
      },
      total: 0,
      activeName: "bpmnPageProcess",
      tabJson: {},
      seach: "",
      cpType: "0",
      allExport: false,
      tableData: [],
      tableNew: [],
      loadingSp: false,
      rowObj: {},
      instIdRow: [],
      leaData: {
        type: "",
        instIds: "",
        show: false,
      },
      numCs: "",
      paramProSearch: {
        current: 1,
        size: 10,
        total: 200,
      },
      pageProSizes: [10, 20, 30, 50, 100],
      //学费缴费，图书归还仅在离校时显示
      lxShow: false,
      bussKeywords: "",
      billNo: "",
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.getBpmnCountPersonProcess();
    this.getNumCsData();
    this.getListFn();
  },
  methods: {
    subTrue() {
      this.getBpmnCountPersonProcess();
      this.getNumCsData();
      this.getListFn();
    },
    cpChange() {
      this.getNumCsData();
      this.getListFn();
    },
    getNumCsData() {
      serve
        .getNumCs()
        .then((res) => {
          if (res.data.code == "0") {
            this.numCs = res.data.data == 0 ? "" : res.data.data;
          } else {
            this.$message.warning(res.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error("服务器异常!");
        });
    },
    handleSelectionChange(val) {
      this.instIdRow = val;
    },
    spClick(type) {
      if (
        this.instIdRow.map((a) => !(a.qfje == 0 && a.sbwh == 0)).filter((r) => r).length >
          0 &&
        this.lxShow
      ) {
        this.$alert("你选择的数据存在未缴费或图书未归还，请重新选择!", "提示", {
          confirmButtonText: "确定",
          type: "warning",
        });
      } else {
        this.leaData.type = type;
        this.leaData.taskIds = this.instIdRow
          .map((item) => {
            return item.taskId;
          })
          .join(",");
        this.leaData.show = true;
      }
    },
    //跳转到填报任务页面
    toRoute() {
      this.$router.push(`/management/reportManage`);
    },
    handleReportList(item) {
      let processDefId = item.processDefId;
      let detailId = item.detailId;
      let isMobile = false;
      serve
        .bpmnStartProcessNew({ processDefId, detailId, isMobile })
        .then(({ data }) => {
          if (data.code == 0) {
            this.$refs.IframeView.showView(data.data.url, data.data.taskInstId);
            // let params= {
            //     batchNo: item.batchNo,
            //     reportId: item.reportId
            // }
            // serve.bpmnSubmitMyReport(params).then(({data})=> {
            //     if (data.code == 0) {
            this.getListFn();
            //     } else {
            //         this.$message.warning(data.msg||'流程系统业务忙，请刷新或者重新操作');

            //     }
            // })
          } else {
            this.$message.warning("流程系统业务忙，请刷新或者重新操作");
          }
        })
        .catch((err) => {
          this.$message.error("服务异常");
        });
    },
    getDateDiff(value) {
      return getDateDiff(value);
    },
    liClick(item) {
      //仅在离校申请列表显示学费缴纳，图书归还
      if (item.processDefCode == "WMLX") {
        this.lxShow = true;
      } else {
        this.lxShow = false;
      }
      if (this.activeName == "getMyReportList") {
        return;
      }
      if (this.activeName == "bpmnPageProcess") {
        this.paramProSearch.size = 10;
        this.paramProSearch.current = 1;
        this.allExport = true;
        this.rowObj = item;
        this.getSpData();
        return;
      }
      this.$refs.IframeView.showView(item.taskUrl, item.taskId);
    },
    getPage() {
      this.paramProSearch.size = 10;
      this.paramProSearch.current = 1;
      this.getBpmnCountPersonProcess();
      this.getSpData();
    },
    getSpData() {
      this.loadingSp = true;
      let params = {
        ...this.paramProSearch,
        processDefCode: this.rowObj.processDefCode || "",
      };
      serve
        .bpmnPageTodoProcess(params)
        .then(({ data }) => {
          this.loadingSp = false;
          if (data.code == 0) {
            let datas = data.data.records;
            this.tableNew = datas.filter((item) => item.processVerId == "WMLX");
            if (this.tableNew.length > 0) {
              let str = this.tableNew
                .map((a) => {
                  return a.instId;
                })
                .join(",");
              this.getTableDataStatus(str, data.data.total);
            } else {
              this.tableData = datas || [];
              this.paramProSearch.total = data.data.total;
            }
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    getTableDataStatus(str, total) {
      let params = {
        instIdStr: str,
      };
      // this.$http.post( "/jsaas/sys/db/sysSqlCustomQuery/queryForJson_qfwhts.do", params,{ baseURL: "/jsaas" } )
      //     .then( ({ data }) => {
      //         console.log(data,'data234223');
      //     })
      //     .catch(() => {
      //
      //     })
      serve.getMsgStatus(params).then((res) => {
        if (res.data.data.length > 0) {
          let data = res.data.data;
          this.tableData = this.tableNew.map((a, i) => {
            return {
              ...a,
              qfje: data[i].qfje,
              sbwh: data[i].sbwh,
              xqmc: data[i].xqmc,
            };
          });
          this.paramProSearch.total = total;
        }
      });
    },
    goBack() {
      this.allExport = false;
      this.getListFn();
    },
    handleClick() {
      this.bussKeywords = "";
      (this.billNo = ""), (this.paramSearch.size = 10);
      this.paramSearch.current = 1;
      if (this.activeName != "bpmnPageProcess") {
        this.allExport = false;
      }
      this.getNumCsData();
      this.getListFn();
      this.getBpmnCountPersonProcess();
    },
    getBpmnCountPersonProcess() {
      serve
        .bpmnCountPersonProcess()
        .then(({ data }) => {
          if (data.code == 0) {
            this.tabJson = data.data || {};
          }
        })
        .catch((err) => {});
    },
    getListFn() {
      this.loading = true;
      let params = {
        ...this.paramSearch,
        keywords: this.seach,
        cpType: this.cpType,
        requestType: "pc",
        bussKeywords: this.bussKeywords,
        billNo: this.billNo,
      };
      serve[this.activeName](params)
        .then(({ data }) => {
          this.loading = false;
          if (data.code == 0) {
            this.list = data.data.records || [];
            this.total = data.data.total;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 条数
    changeSize(value) {
      this.paramSearch.size = value;
      this.paramSearch.current = 1;
      this.getListFn();
    },
    // 翻页
    changePage(value) {
      this.paramSearch.current = value;
      this.getListFn();
    },
    // 条数
    changeProSize(value) {
      this.paramProSearch.size = value;
      this.paramProSearch.current = 1;
      this.getSpData();
    },
    // 翻页
    changeProPage(value) {
      this.paramProSearch.current = value;
      this.getSpData();
    },
  },
  watch: {},
  filters: {},
};
</script>

<style scoped lang="less">
/deep/.el-tabs__item.is-active {
  color: #064576;
}
/deep/.el-tabs__active-bar {
  background-color: #064576;
}
/deep/#tab-bpmnPageProcess {
  width: 80px;
  text-align: center;
}
.table-con {
  /*height:calc(100vh - 240px);*/
  overflow: auto;
  ul {
    li {
      .rows {
        .cols {
          cursor: pointer;
          height: 60px;
          background: #f7f7f7;
          padding: 0 8px;
          line-height: 60px;
          margin-bottom: 9px;
          padding-right: 5px;
          &.bpmnPageProcess {
            cursor: initial;
          }
          &:hover {
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05), 0 0 3px rgba(0, 0, 0, 0.04);
          }
          > .icon {
            width: 20px;
            padding-top: 15px;
          }
          > span {
            display: inline-block;
            vertical-align: top;
            padding: 0 12px;
            &.name {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            &.reportStatus {
              width: 80px;
              height: 30px;
            }
            .el-icon-time {
              margin-left: 20px;
              font-weight: bold;
              color: #666;
            }
            .spanBtn {
              padding: 8px 23px;
              color: #ffffff;
            }
          }
          > .task-num {
            margin-top: 15px;
            min-width: 66px;
            height: 30px;
            line-height: 30px;
            margin-left: 20px;
            font-family: Microsoft YaHei;
            font-weight: 400;
          }
          > .mytasks {
            background: #e8f7fa;
            color: #39c0db;
          }
          > .histasks {
            background: #ffefef;
            color: #f36f6f;
          }
        }
      }
    }
  }
}
</style>
